import { apiRequest } from "@core/services/api/apiRequest";
import { VIDEO_API } from "../videoMeeting.constants";
import type { VideoRoomAccessResponse } from "../videoMeeting.types";

export const verifyVideoMeetingAccess = async (
  roomId: number
): Promise<VideoRoomAccessResponse> => {
  return apiRequest(VIDEO_API.VERIFY_ACCESS(roomId), "GET");
};
